import { useEffect, useState } from 'react'
import { LookUpInvitation } from '../services/peerToPeer/InvitationService'
import { getInviteToken } from '../pages/pageComponents/peerToPeer/auth/inviteToken'

export type InviteLookupState =
  | { status: 'loading' }
  | { status: 'invalid' }
  | { status: 'valid', token: string, email: string }

export const useP2PInviteLookup = (): InviteLookupState => {
  const [state, setState] = useState<InviteLookupState>({ status: 'loading' })

  useEffect(() => {
    const token = getInviteToken()
    if (token == null) {
      setState({ status: 'invalid' })
      return
    }

    let isCurrent = true
    const load = async (): Promise<void> => {
      const { success, response } = await LookUpInvitation(token)
      if (!isCurrent) return
      if (success && response != null && response.isValid && response.email != null) {
        setState({ status: 'valid', token, email: response.email })
      } else {
        setState({ status: 'invalid' })
      }
    }

    void load()
    return () => { isCurrent = false }
  }, [])

  return state
}
